import { MAX_WIDTH_PETIT_SMARTPHONE } from '@/constants/sizes';

class DeviceUtils {
  static isMobile(): boolean {
    return window.innerWidth <= MAX_WIDTH_PETIT_SMARTPHONE;
  }
}

export default DeviceUtils;
